// extracted by mini-css-extract-plugin
module.exports = {"root":"basicInformationStep_root__38cU1","characterCount":"basicInformationStep_characterCount__39_UI"};